module.exports = __webpack_public_path__ + "img/timeline.a9726324.png";